import Illustration from './work-in-progress-illustration.svg';

export function WorkInProgress() {
  return (
    <div className="flex flex-col items-center justify-center h-screen px-4">
      <img src={Illustration} width={250} />
      <h1 className="text-2xl font-bold mb-4">Under konstruktion...</h1>
      <p className="text-gray-600 dark:text-gray-300 text-center">
        Just nu förbereder vi höstens försäljningsomångar. Kom tillbaka nästa vecka för att skapa din Piggogrupp!
      </p>
    </div>
  );
}
